import React from "react";
import t from "../utils/t";

interface IProps {
    message: string;
    title: string;
    onClose(): void;
}

export default class SimpleModal extends React.Component<IProps> {
    public render(): JSX.Element {
        const {
            onClose,
            title,
            message,
        } = this.props;

        return (
            <div className="modal is-active">
                <div
                    className="modal-background"
                    onClick={ onClose }
                ></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <div className="modal-card-title">
                            { title }
                        </div>
                            <button
                                className="delete"
                                aria-label="close"
                                onClick={ onClose }
                            ></button>
                    </header>
                    <section className="modal-card-body">
                        { message }
                    </section>
                    <footer className="modal-card-foot">
                        <button
                            className="button"
                            onClick={ onClose }
                        >{ t("CLOSE") }</button>
                    </footer>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SimpleModal.tsx